export default [
  {
    path: '/loan',
    name: 'financial-loan',
    meta: {
      requiresAuth: true,
      title: 'Empréstimo'
    },
    component: () =>
      import(/* webpackChunkName: "profile" */ '@/components/loan/LoanList.vue')
  }
]
